import { CloseCircleFilled, CloseOutlined, MinusOutlined, SwapRightOutlined } from '@ant-design/icons';
import { Button, InputNumber } from 'antd';
import { FC, useEffect, useMemo, useState } from 'react';
import styles from './index.module.less';
import clsx from 'clsx';
import { constant } from 'lodash-es';
import { CSSProperties } from '@ant-design/cssinjs/lib/hooks/useStyleRegister';

enum InputType {
  MIN = 0,
  MAX = 1,
}

type NumberRangeProps = {
  width?: number;
  value?: [number | null, number | null];
  min?: number;
  max?: number;
  precision?: number;
  disabled?: boolean;
  placeholder?: [string | null, string | null];
  size?: 'small' | 'middle' | 'large';
  style?: CSSProperties | undefined;
  onChange?: (value: [number | null, number | null]) => void;
};

const NumberRange: FC<NumberRangeProps> = ({
  width,
  value = [null, null],
  precision = 2,
  // min = 0,
  // max = 99999999.99,
  min = -Infinity,
  max = Infinity,
  disabled = false,
  placeholder = [min !== -Infinity ? min + '' : '最小值', max !== Infinity ? max + '' : '最大值'],
  size = 'middle',
  style,
  onChange,
}) => {
  // 状态管理
  const [internalValue, setInternalValue] = useState(value)
  const [focusedField, setFocusedField] = useState<'min' | 'max' | null>(null)

  const handleChange = (v: any, type: InputType) => {
    // console.log('numberRange change: ', v)
    const newValue = (type === InputType.MIN ? [v, internalValue[1]] : [internalValue[0], v]) as [number | null, number | null]
    setInternalValue(newValue)
    onChange?.(newValue)
  };

  const handleBlur = (e) => {
    // console.log(e)
    const [minValue, maxValue] = internalValue;
    if (minValue && maxValue && minValue > maxValue) {
      setInternalValue([maxValue, minValue])
      onChange?.([maxValue, minValue])
    }
    setFocusedField(null)
  }

  const handleClear = (e) => {
    setInternalValue([null, null])
    onChange?.([null, null])
  }

  // 渲染输入框
  // const renderInputNumber = (type: InputType) => (
  //   <InputNumber
  //     placeholder={placeholderSuffix[type]}
  //     value={value[type]}
  //     onChange={(v) => handleChange(v, type)}
  //     className={`${styles.rangeInput} ${type === InputType.MIN ? styles.leftInput : styles.rightInput}`}
  //     min={min}
  //     max={max}
  //     precision={precision}
  //     controls={false}
  //     {...inputNumberProps}
  //   />
  // );

  // 样式类名计算
  const [container, setContainer] = useState(null)
  useEffect(() => {
    const classnames = ['number-range', `number-range-${size}`]
    if (focusedField) {
      classnames.push('number-range-focused')
    }
    if (disabled) {
      classnames.push('number-range-disabled')
    }
    setContainer(clsx(...classnames.map(c => styles[c])))
  }, [focusedField])

  const internalStyle = useMemo(() => {
    let val = {}
    if (width) {
      val = { ...val, width: `${width}px` }
    }
    if (style) {
      val = { ...val, ...style }
    }
    return val
  }, [style, width])

  return (
    // <div className={container}  style={width && { width: `${width}px` }}>
    <div className={container} style={internalStyle}>
      <div className={styles['number-range-input-group']}>
        <InputNumber
          placeholder={placeholder[InputType.MIN]}
          value={internalValue[InputType.MIN]}
          style={internalValue[InputType.MIN] ? { backgroundColor: '#F5FAFE' } : null}
          onChange={(v) => handleChange(v, InputType.MIN)}
          // className={`${styles.rangeInput} ${styles.leftInput}`}
          className={styles['number-range-input']}
          min={min}
          max={internalValue[InputType.MAX] ?? max}
          precision={precision}
          disabled={disabled}
          controls={false}
          onFocus={() => setFocusedField('min')}
          onBlur={(e) => handleBlur(e)}
        />
        {/* <SwapRightOutlined className={styles.separator} /> */}
        {/* <SwapRightOutlined /> */}
        <MinusOutlined />
        <InputNumber
          placeholder={placeholder[InputType.MAX]}
          value={internalValue[InputType.MAX]}
          style={internalValue[InputType.MAX] ? { backgroundColor: '#F5FAFE' } : null}
          onChange={(v) => handleChange(v, InputType.MAX)}
          // className={`${styles.rangeInput} ${styles.rightInput}`}
          className={styles['number-range-input']}
          min={internalValue[InputType.MIN] ?? min}
          max={max}
          precision={precision}
          disabled={disabled}
          controls={false}
          onFocus={() => setFocusedField('max')}
          onBlur={(e) => handleBlur(e)}
        />
        {
          !disabled && (!!internalValue[InputType.MIN] || !!internalValue[InputType.MAX]) ?
            <div className={styles['number-range-clear']} onClick={handleClear}><CloseCircleFilled /></div> : null
        }
      </div>
    </div>
  );
};

export default NumberRange;
